import React, { useState, useEffect, useCallback } from 'react';

const styles = {
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
    gap: "16px",
    padding: "20px",
  },

  card: {
    height: "220px",
    overflow: "hidden",
    borderRadius: "16px",
    cursor: "pointer",
  },

  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    transition: "transform 0.4s ease",
  },

  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    background: "rgba(0,0,0,0.95)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  },

  fullImage: {
    maxWidth: "90%",
    maxHeight: "90%",
    objectFit: "contain",
    transition: "transform 0.2s ease",
  },

  close: {
    position: "absolute",
    top: "20px",
    right: "30px",
    fontSize: "30px",
    color: "white",
    background: "none",
    border: "none",
    cursor: "pointer",
  },

  prev: {
    position: "absolute",
    left: "20px",
    fontSize: "40px",
    color: "white",
    background: "none",
    border: "none",
    cursor: "pointer",
  },

  next: {
    position: "absolute",
    right: "20px",
    fontSize: "40px",
    color: "white",
    background: "none",
    border: "none",
    cursor: "pointer",
  },

  moreContainer: {
    textAlign: "center",
    padding: "20px",
  },

  moreButton: {
    padding: "12px 30px",
    backgroundColor: "#d8a7b1",
    color: "#fff",
    border: "none",
    borderRadius: "25px",
    fontSize: "16px",
    cursor: "pointer",
  },
};

const MariageGallery = () => {
  const getBatchSize = () => {
    const width = window.innerWidth;

    if (width <= 767) return 5;
    if (width <= 1024) return 6;
    return 12;
  };

  const [selectedIndex, setSelectedIndex] = useState(null);
  const [scale, setScale] = useState(1);
  const [batchSize, setBatchSize] = useState(getBatchSize);
  const [visibleCount, setVisibleCount] = useState(getBatchSize);

  const photos = [
    ...Array.from({ length: 21 }, (_, i) => `/img/version1/mariage/mariage1/mariage (${i + 1}).jpg`),
    ...Array.from({ length: 13 }, (_, i) => `/img/version1/mariage/mariage2/mariage (${i + 1}).jpg`),
    ...Array.from({ length: 9 }, (_, i) => `/img/version1/mariage/mariage3/mariage (${i + 1}).jpg`),
    ...Array.from({ length: 9 }, (_, i) => `/img/version1/mariage/mariage4/mariage (${i + 1}).jpg`),
    ...Array.from({ length: 5 }, (_, i) => `/img/version1/mariage/mariage5/mariage (${i + 1}).jpg`),
    ...Array.from({ length: 13 }, (_, i) => `/img/version1/mariage/mariage6/mariage (${i + 1}).jpg`),
    ...Array.from({ length: 5 }, (_, i) => `/img/version1/mariage/mariage7/mariage (${i + 1}).jpg`),
    ...Array.from({ length: 5 }, (_, i) => `/img/version1/mariage/mariage8/mariage (${i + 1}).jpg`),
    ...Array.from({ length: 14 }, (_, i) => `/img/version1/mariage/mariage9/mariage (${i + 1}).jpg`),
    ...Array.from({ length: 4 }, (_, i) => `/img/version1/mariage/mariage10/mariage (${i + 1}).jpg`),
    ...Array.from({ length: 3 }, (_, i) => `/img/version1/mariage/mariage11/mariage (${i + 1}).jpg`),
    ...Array.from({ length: 5 }, (_, i) => `/img/version1/mariage/mariage12/mariage (${i + 1}).jpg`),
    ...Array.from({ length: 5 }, (_, i) => `/img/version1/mariage/mariage13/mariage (${i + 1}).jpg`),
    ...Array.from({ length: 4 }, (_, i) => `/img/version1/mariage/mariage14/mariage (${i + 1}).jpg`),
    ...Array.from({ length: 7 }, (_, i) => `/img/version1/mariage/mariage15/mariage (${i + 1}).jpg`),
    ...Array.from({ length: 20 }, (_, i) => `/img/version1/mariage/bouquets/mariage (${i + 1}).jpg`),
    ...Array.from({ length: 11 }, (_, i) => `/img/version1/mariage/decoration/mariage (${i + 1}).jpg`),
    ...Array.from({ length: 6 }, (_, i) => `/img/version1/mariage/voiture/mariage (${i + 1}).jpg`),
  ];

  useEffect(() => {
    const handleResize = () => {
      const newBatchSize = getBatchSize();

      setBatchSize(newBatchSize);

      setVisibleCount((current) => {
        if (current >= photos.length) return photos.length;
        return Math.max(current, newBatchSize);
      });
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [photos.length]);

  const close = useCallback(() => {
    setSelectedIndex(null);
    setScale(1);
  }, []);

  const next = useCallback((e) => {
    if (e) e.stopPropagation();

    setSelectedIndex((prev) => (prev + 1) % photos.length);
    setScale(1);
  }, [photos.length]);

  const prev = useCallback((e) => {
    if (e) e.stopPropagation();

    setSelectedIndex((prev) =>
      prev === 0 ? photos.length - 1 : prev - 1
    );

    setScale(1);
  }, [photos.length]);

  useEffect(() => {
    const handleKey = (e) => {
      if (selectedIndex === null) return;

      if (e.key === "ArrowRight") next();
      if (e.key === "ArrowLeft") prev();
      if (e.key === "Escape") close();
    };

    window.addEventListener("keydown", handleKey);

    return () => window.removeEventListener("keydown", handleKey);
  }, [selectedIndex, next, prev, close]);

  const handleWheel = (e) => {
    e.stopPropagation();

    setScale((prev) =>
      Math.min(Math.max(prev - e.deltaY * 0.001, 1), 3)
    );
  };

  let startX = 0;

  const handleTouchStart = (e) => {
    startX = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    const endX = e.changedTouches[0].clientX;

    if (startX - endX > 50) next(e);
    if (endX - startX > 50) prev(e);
  };

  return (
    <>
      <div style={styles.grid}>
        {photos.slice(0, visibleCount).map((src, index) => (
          <div
            key={index}
            style={styles.card}
            onClick={() => setSelectedIndex(index)}
          >
            <img
              src={src}
              alt={`Composition florale de mariage fleuriste Chennevières-sur-Marne ${index + 1}`}
              style={styles.image}
              loading="lazy"
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
              }}
            />
          </div>
        ))}
      </div>

{visibleCount < photos.length && (
  <div style={styles.moreContainer}>
    <button
      type="button"
      style={{
        ...styles.moreButton,
        backgroundColor: "#DF9BA4",
        color: "#FFFFFF",
        border: "none",
      }}
      onClick={() => {
        setVisibleCount((current) =>
          Math.min(current + batchSize, photos.length)
        );
      }}
    >
      Voir plus
    </button>
  </div>
)}



      {selectedIndex !== null && (
        <div style={styles.overlay} onClick={close}>
          <button
            style={styles.close}
            onClick={close}
            aria-label="Fermer"
          >
            ✕
          </button>

          <button
            style={styles.prev}
            onClick={prev}
            aria-label="Photo précédente"
          >
            ‹
          </button>

          <img
            src={photos[selectedIndex]}
            alt={`Composition florale de mariage ${selectedIndex + 1}`}
            style={{
              ...styles.fullImage,
              transform: `scale(${scale})`,
            }}
            onClick={(e) => e.stopPropagation()}
            onWheel={handleWheel}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
          />

          <button
            style={styles.next}
            onClick={next}
            aria-label="Photo suivante"
          >
            ›
          </button>
        </div>
      )}
    </>
  );
};

export default MariageGallery;

